import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

import { ConsumidorModel, ConsumidorFormatter, ConsumidorService } from '../shared/';
import { LoginService } from '../shared/login.service';

import {
  MaskManager, CPFValidator, ConfiguracoesProjeto, ParametrosService, NbpInfoComponent,
  NbpConfirmComponent,
  UtilHelper
} from '../../../shared';
import { SessionStorageSorteio } from '../../../publico/sorteios/shared/session-storage-sorteio';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { RecaptchaSafety } from '../../../shared/security/RecaptchaSafety';
import { CidadaoLgpd } from '../consumidor-lgpd/cidadao-lgpd';
import { StatusCpfCidadao } from '../../../shared/model/status-cpf-cidadao.model';
import { environment } from '../../../../environments/environment';
import { NbpOnlyConfirmComponent } from '../../../shared/modal/nbp-only-confirm.component';

interface IValidation {
  [key: string]: boolean;
}

@Component({
  selector: 'app-consumidor-login',
  templateUrl: './consumidor-login.component.html',
  styleUrls: []
})
export class ConsumidorLoginComponent implements OnInit {

  public loginForm: FormGroup;    
  public consumidor: ConsumidorModel;
  public active = true;
  public maskCPF = MaskManager.CPF;
  public msgErroLogin = '';
  public recaptcha: string;
  public config: ConfiguracoesProjeto;

  public validRecaptcha = false;
  public useRecaptcha = true;

  public mensagemModalImpedido: string = null;
  public maskDataPadrao = 'YYYY-MM-DD';
  public maskDataFull = 'YYYY-MM-DD HH:mm:ss';

  formErrors = {
    'cpf': [],
    'senha': []
  };

  public validationMessages = {
    'cpf': {
      'required': 'O Campo CPF é de preenchimento obrigatório.',
      'cpfInvalido': 'Informe um CPF válido.',
      'cpfNaoCadastrado': 'Não foi possível identificar sua conta.',
      'cpfImpedido': 'Cidadão com CPF bloqueado para participação dos sorteios na Campanha NPB.',
      'cpfBloqueado': 'Cidadão com CPF bloqueado para uso do sistema.',
      'cpfOrigemGovbr' : 'O seu acesso deve ser realizado através do botão "Entrar com gov.br".'
    },
    'senha': {
      'required': 'O Campo Senha é de preenchimento obrigatório.',
      'minlength': 'Senha Inválida! A senha deve possuir no mínimo 6 caracteres',
      'maxlength': 'Senha Inválida! A senha deve possuir no máximo 15 caracteres'
    }
  };
  

  constructor(private readonly loginService: LoginService,
              private readonly router: Router,
              private readonly route: ActivatedRoute,
              private readonly consumidorService: ConsumidorService,
              private readonly parametrosService: ParametrosService,
              private readonly sessionStorageSorteio: SessionStorageSorteio,
              private readonly ngbModalService: NgbModal) {
  }

  ngOnInit() {

    this.mensagemModalImpedido = null;

    this.consumidorService.editSenhaMode = false;
    this.config = this.parametrosService.getConfiguracao();

    if(this.config.ambiente == RecaptchaSafety.AmbienteUsoObrigatorioRecaptcha) {
      this.useRecaptcha = true;
      this.recaptcha = this.config.recaptcha;
    }else{
      this.useRecaptcha = false;
      this.validRecaptcha = true;
    }

    this.consumidor = new ConsumidorModel();
    this.consumidorService.setEditMode(false);
    this.loginService.logout();

    this.loginForm = new FormGroup({
      'cpf': new FormControl(this.consumidor.cpf,
        [Validators.required, CPFValidator.validaCPF.bind(this)],
        [this.validaCpfExiste.bind(this)]
      ),
      'senha': new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(15)])
    });
    
    this.loginForm.valueChanges
      .subscribe(data => this.onValueChanged(data));

    // OBSERVADOR QUE AGUARDA O RETORNO DO LOGIN DO USUARIO, REDIRECIONA OU CARREGA OS DADOS DO USUARIO NO LOCALSTORAGE
    this.loginService.loginAutorized
      .subscribe(
      (data) => {
        if (data.logado) {
          const _consumidor = this.consumidorService.getConsumidorModel();
          this.consumidorService.setEditMode(true);

            if(CidadaoLgpd.TermoLgpdAceito()) {

              this.msgErroLogin = '';
              this.sessionStorageSorteio.DefinirSessionStoragePeriodoSorteioMensalAtual();

              // verifica se tem 6 meses que a ultima atualização foi feita, caso não tenha sido feita
              // sugerir para o usuário a realização da atualização do cadastro
              var dataFormatada = null;
              if (_consumidor.dataAtualizacaoContato != null ){
                dataFormatada = UtilHelper.ParseStringToDate(_consumidor.dataAtualizacaoContato, this.maskDataFull, this.maskDataFull);
               
                if (_consumidor.dataAtualizacaoContato != null && this.PassouSeisMesesDesdeUltimaAtualizacaoContato(dataFormatada)){
                  this.router.navigate(['atualizar-cadastro'], {relativeTo: this.route});
                } else{
                  this.router.navigate(['detalhar'], { relativeTo: this.route });
                }
              } else {
                this.router.navigate(['atualizar-cadastro'], {relativeTo: this.route});
              }
              
              
              
              if (this.mensagemModalImpedido) {
                const confirmModal = this.ngbModalService.open(NbpInfoComponent);
                confirmModal.componentInstance.info = this.mensagemModalImpedido;
              }

          }else{
                this.router.navigate(['termo-lgpd'], { relativeTo: this.route });
          }

        } else {

          this.consumidorService.setEditMode(false);
          this.msgErroLogin = data.mensagem;
          this.mensagemModalImpedido = null;
        }
      }
      );
  }

  validaCpfExiste(control: AbstractControl): Promise<ValidationErrors|null>|Observable<ValidationErrors|null> {

    const cpf = control.value.replace(/\.|\-|\_/g, '');

    const q = new Promise<IValidation>((resolve, reject) => {
      this.consumidorService.getStatusCPF(cpf).subscribe(
        (data) => {

          let dataResult = data as StatusCpfCidadao;
          
          this.mensagemModalImpedido = null;
          switch (dataResult.statusCpf) {
            case 1:
                this.formErrors.cpf.push(this.validationMessages.cpf.cpfNaoCadastrado);
                resolve({'cpfNaoCadastrado': true});
                break;
            case 2:
                this.formErrors.cpf.push(this.validationMessages.cpf.cpfBloqueado);
                resolve({'cpfBloqueado': true});
                break;
            case 3:
                this.mensagemModalImpedido = 'Cidadão com CPF impedido para participação dos sorteios na Campanha NPB.';
                resolve(null);
                break;
            case 4:
                resolve(null);
                break;
            default:

            // BA.GOV.BR
            if(data.codOrigemCadastro == 2 && data.senhaCadastrada == false) {
              
                const modalRef = this.ngbModalService.open(NbpOnlyConfirmComponent, { backdrop: 'static', keyboard: false, size: 'lg' });
                modalRef.componentInstance.mensagem = "Favor cadastrar a Senha para acesso ao Portal do NPB.";
                modalRef.componentInstance.userConfirmChange.subscribe((userConfirm) => {
                  if(userConfirm) {
                    var cpf = ConsumidorFormatter.formataString(this.loginForm.get('cpf').value)
                    sessionStorage.setItem('cpfConsumidor', cpf);
                    this.router.navigate(['/cadastrar-senha-externo']);
                  }
                });
                
           }else {
                resolve(null);
            }         
          }
        }, error => {

          let err = error as StatusRequisicao;
          this.msgErroLogin = err.motivo;

        });
    });
    return q;
  }

  onSubmit() {

    localStorage.setItem('login_via_gov_br', "0");

    this.consumidor.cpf = ConsumidorFormatter.formataString(this.loginForm.get('cpf').value);
    this.consumidor.senha = this.loginForm.get('senha').value;
    this.loginService.login(this.consumidor);
  }

  resolved(captchaResponse: string) {
    this.validRecaptcha = true;
  }

  onValueChanged(data?: any) {

    for (const campo in this.formErrors) {
      const control = this.loginForm.get(campo);
      this.formErrors[campo] = [];

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[campo];
        for (const key in control.errors) {
          if (messages[key]) {
            this.formErrors[campo].push(messages[key]);
          }
        }
      }
    }
    this.msgErroLogin = '';
  }

  RedirectToGovBr() {

     window.location.href = environment.url_login_gov_br;   
  }

  PassouSeisMesesDesdeUltimaAtualizacaoContato(dataUltimaAtualizacao: Date){
    const hoje  = new Date();
    dataUltimaAtualizacao.setMonth(dataUltimaAtualizacao.getMonth() + 6)
    return hoje >= dataUltimaAtualizacao;
  }

}


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-login/consumidor-login.component.ts